// Onboarding'in "Kullanıcı Tipleri" ve "Kullanıcı Yetkileri" adımlarında
// gösterilen varsayılan liste. Backend'deki `DEFAULT_USER_ROLES` (server.py
// L16038) ve `assign_default_permissions` (server.py L14145) yapılarını
// aynen yansıtır — bir değişiklik olursa iki tarafta da güncellenmeli.
export const DEFAULT_USER_TYPES = [
  'Süper Admin', 'Admin', 'CEO', 'CFO', 'CHRO', 'CIO', 'CMO', 'COO', 'CTO',
  'Genel Müdür', 'Genel Müdür Yardımcısı', 'Yönetim Kurulu Başkanı',
  'Yönetim Kurulu Üyesi', 'Icra Kurulu Üyesi', 'Finans Direktörü',
  'Finans Müdürü', 'Finans Uzmanı', 'Muhasebe Müdürü', 'Muhasebe Uzmanı',
  'Muhasebe', 'Mali Müşavir', 'Mali İşler Müdürü', 'Ön Muhasebe Elemanı',
  'Proje Yöneticisi', 'İdari İşler', 'İdari Asistan', 'Ofis Asistanı',
  'İnsan Kaynakları Müdürü', 'İşe Alım Müdürü', 'IK Uzmanı',
  'Bordro ve Özlük Müdürü', 'Satın Alma Müdürü', 'Satın Alma Uzmanı',
  'Satınalma', 'Satış Müdürü', 'Satış Yöneticisi', 'Satış Temsilcisi',
  'Bölge Satış Yöneticisi', 'İhracat Müdürü', 'Pazarlama Müdürü',
  'Dijital Pazarlama Müdürü', 'Marka Müdürü', 'CRM Müdürü', 'Ürün Müdürü',
  'Ar-Ge Müdürü', 'Yazılım Geliştirme Müdürü', 'Yazılım Mimarı',
  'Kıdemli Yazılım Geliştirici', 'Junior Yazılım Geliştirici',
  'Frontend Developer', 'Backend Developer', 'Full Stack Developer',
  'Mobil Uygulama Geliştirici', 'UI/UX Tasarımcı', 'Grafik Tasarımcı',
  'DevOps Müdürü', 'Sistem Yöneticisi', 'Siber Güvenlik Müdürü',
  'Network Uzmanı', 'IT Destek Uzmanı', 'Bilgi İşlem Müdürü',
  'Veri Analisti', 'Veri Bilimci', 'Kalite Kontrol Müdürü',
  'Kalite Kontrol Uzmanı', 'Kalite Kontrol Elemanı', 'Üretim Müdürü',
  'Üretim Operatörü', 'Üretim Planlama Uzmanı', 'Makine Operatörü',
  'Bakım Teknisyeni', 'Teknisyen', 'Teknik Müdür', 'Lojistik Müdürü',
  'Lojistik Uzmanı', 'Tedarik Zinciri Müdürü', 'Depo Sorumlusu',
  'Depo Elemanı', 'Kargo Sorumlusu', 'Kurye', 'Şoför', 'Müşteri Temsilcisi',
  'Müşteri Hizmetleri Temsilcisi', 'Sekreter', 'Resepsiyonist',
  'Genel Sekreter', 'Stajyer', 'Süpervisor', 'Vardiya Şefi',
  'Tasarım', 'Hukuk Müdürü', 'Vergi Uzmanı', 'Mali Analist',
  'Bütçe ve Planlama Müdürü', 'Eğitim ve Gelişim Müdürü', 'Eğitim Uzmanı',
  'Sosyal Medya Yöneticisi', 'İçerik Yöneticisi',
  'Kurumsal İletişim Müdürü', 'Güvenlik Görevlisi', 'Temizlik Görevlisi',
  'Mutfak Personeli',
];

export const DEFAULT_PERMISSION_CATEGORIES = [
  {
    key: 'modules',
    icon: '🧭',
    label: 'Modül Erişimi',
    items: [
      'Dashboard, Yeni Avans Talebi, Tüm Talepler',
      'Bekleyen/Onaylı Avanslar, Avans Kapatma',
      'Finans Onayı, Kapanmış Avanslar, Cari Hesap',
      'Raporlar & Ayarlar (Admin)',
    ],
  },
  {
    key: 'approval_actions',
    icon: '✅',
    label: 'Onay Aksiyonları',
    items: [
      'Ekibindeki talepleri onayla / reddet',
      'Departman ve tüm şirket seviyesinde onay (Admin)',
    ],
  },
  {
    key: 'finance_actions',
    icon: '💳',
    label: 'Finans Aksiyonları',
    items: [
      'Finans onayı ve ödeme (rol seviyesine göre)',
      'Admin: tüm şirket bazında finans işlemleri',
    ],
  },
  {
    key: 'closing_actions',
    icon: '📁',
    label: 'Avans Kapatma',
    items: [
      'Kendi avansını kapatma (herkes)',
      'Ekip / departman / tüm şirket kapama (rol bazlı)',
    ],
  },
  {
    key: 'data_access',
    icon: '🔍',
    label: 'Veri Erişimi',
    items: [
      'Kendi verini görüntüle',
      'Ekip / departman / tüm şirket verisi (yetki bazlı)',
    ],
  },
  {
    key: 'administrative',
    icon: '⚙️',
    label: 'Yönetim',
    items: [
      'Kullanıcı yönetimi (ekip / departman / tüm şirket)',
      'Kategori yönetimi, veri dışa aktarma',
    ],
  },
  {
    key: 'reporting',
    icon: '📊',
    label: 'Raporlama',
    items: [
      'Kendi / ekip / departman raporları',
      'Tüm şirket raporları + özel rapor oluşturma (Admin)',
    ],
  },
];
